import * as storage from 'client/javascript/storage';
import NumberStepper from 'client/javascript/number_stepper';
import { isEnterKeyPress } from 'client/javascript/util/keypress';
import { localizeLink } from 'client/javascript/util/locale';
import { stringify } from 'qs';
import { getDesiredCapacityValue, getSelectedLocation, setDesiredCapacityValue, WIZARD_STEP_2_LINK_ID } from './utils';
import Wizard from './wizard';

const CHECK_AVAILABILITY_ID = 'check_availability';
const STEP1_LOCATION_TITLE = 'step1-location-title';

function getMarketPageUrl() {
  const selectedLocation = getSelectedLocation();
  const marketPath = selectedLocation.getAttribute('data-market-path');
  const desiredCapacity = getDesiredCapacityValue();
  const queryParams = stringify({ capacity: desiredCapacity });
  const marketPageWithParams = `${marketPath}?${queryParams}`;

  return localizeLink({ to: marketPageWithParams });
}

function handleStoreDesiredCapacity() {
  const desiredCapacity = getDesiredCapacityValue();
  storage.setDesiredCapacity(desiredCapacity);
}

export function setStep1LocationTitle() {
  const step1LocationTitle = document.getElementById(STEP1_LOCATION_TITLE);
  const { label } = getSelectedLocation();
  step1LocationTitle.innerHTML = label;
}

function handleCheckAvailabilityClick(evt) {
  evt.preventDefault();

  handleStoreDesiredCapacity();

  window.location = getMarketPageUrl();
}

function setupWizardStep1(wizard, showWizardStep2) {
  const numberStepperElement = wizard.step1.querySelector('.number-stepper');
  const numberStepperInput = numberStepperElement.querySelector('input');

  // eslint-disable-next-line no-new
  new NumberStepper(numberStepperElement);

  const desiredCapacityFromStorage = storage.getDesiredCapacity();
  const desiredCapacity = desiredCapacityFromStorage || numberStepperInput.value;
  setDesiredCapacityValue(desiredCapacity);

  const checkAvailabilityEl = document.getElementById(CHECK_AVAILABILITY_ID);
  checkAvailabilityEl.addEventListener('click', handleCheckAvailabilityClick);

  if (showWizardStep2) {
    document.getElementById(WIZARD_STEP_2_LINK_ID).addEventListener('click', () => {
      handleStoreDesiredCapacity();
      wizard.goToStep2();
    });

    document.getElementById(WIZARD_STEP_2_LINK_ID).addEventListener('keydown', event => {
      if (isEnterKeyPress(event)) {
        event.currentTarget.click();
      }
    });
  }
}

export default function setupWizard(wizardNode, showWizardStep2) {
  const wizard = new Wizard(wizardNode);

  setupWizardStep1(wizard, showWizardStep2);

  return wizard;
}
